import axios from "axios";

export default axios.create({
  baseURL: "https://fidusindia.in/cit",
});
